import { Helmet } from "react-helmet-async";

const bgBanner = require("../../assets/images/ProductosBannerBg.png");
const banner = require("../../assets/images/UniticketAlimentacion_Banner.png");
const tarjeta = require("../../assets/images/UniticketAlimentacion_Tarjeta.jpg");

const descriptionUniMonedero = [
  {
    title: "Descripción",
    text: "Tarjeta MAESTRO ideal para optimizar los procesos inherentes a cubrir los gastos asociados a la alimentación del personal, que la empresa le otorga a sus trabajadores para satisfacer las necesidades enmarcadas en la Ley.",
    img: tarjeta,
  },
];

const benificiosUM = [
  {
    title: "Beneficios",
    lists: [
      {
        listText:
          "Este producto elimina a la empresa los costos y riesgos de manejo de talones de tickets, así como fletes y acarreos. Ahorro de costos y espacio físico, simplificando los procesos de entrega, conteo y gestión administrativa.",
      },
      {
        listText:
          "Tarjeta afiliada a la red MAESTRO, lo cual garantiza una plataforma con los mayores estándares de seguridad y aceptación.",
      },
      {
        listText:
          "El sistema de Grupo Único posee ágiles y confiables procesos de solicitud de emisión y abono de tarjetas. Asimismo, administra restricciones de uso de la tarjeta según categoría de comercios.",
      },
      {
        listText:
          "Manera práctica, fácil y sencilla de otorgar un beneficio social de carácter no remunerativo, enmarcado en la Ley en el articulo 105 de LOTTT.",
      },
      {
        listText:
          "Cumple con la provisión de comida establecida en la Ley de Alimentación para los Trabajadores y Trabajadoras.",
      },
      {
        listText:
          "Genera al empleado mayor poder adquisitivo y motivación laboral, incrementando el presupuesto familiar y logrando equilibrio en las remuneraciones.",
      },
      {
        listText:
          "Atención al Cliente completamente personalizada a través de nuestra central telefónica y página Web.",
      },
      {
        listText:
          "Grupo Único cuenta con atención integral de todos los servicios financieros y la asesoría que requiere la empresa.",
      },
    ],
  },
];

const UniticketAlimentacion = () => {
  return (
    <div>
      <Helmet>
        <title>Uniticket Alimentacion -Uniticket</title>
      </Helmet>
      <div
        className="relative overflow-hidden bg-no-repeat bg-cover max-w-auto h-auto mb-16"
        style={{
          backgroundPosition: "50%",
          backgroundImage: `url(${bgBanner})`,
          height: "440px",
        }}
      >
        <div className="flex flex-col items-center justify-items-center mt-16 mb-16">
          <img src={banner} className="max-w-full h-auto text-center" alt="" />
          <div className="flex flex-col lg:flex-row mt-8 text-center">
            <p className="text-orange-500 font-bold text-3xl mr-2">
              Uniticket{" "}
            </p>
            <p className="text-white font-bold text-3xl">Alimentacion</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        {descriptionUniMonedero.map(({ title, text, img }, i) => {
          return (
            <div className="flex flex-col lg:flex-row items-center">
              <div className="max-w-auto mx-8 md:ml-28 basic-1/2">
                <p className="text-orange-500 text-3xl font-bold my-10">
                  {title}
                </p>
                <p className="text-gray-500 text-base text-justify my-10">
                  {text}
                </p>
              </div>
              <div className="lg:mr-40 ">
                <img
                  src={img}
                  className="max-w-[100%] sm:max-w-sm px-8 h-auto"
                />
              </div>
            </div>
          );
        })}

        {benificiosUM.map(({ title, lists }, i) => {
          return (
            <div className="max-w-auto mx-8 md:mx-28 basic-1/2 mb-10">
              <p className="text-orange-500 text-3xl font-bold my-10">
                {title}
              </p>
              <div className="flex flex-col justify-center mb-2">
                {lists.map(({ listText }, i) => {
                  return (
                    <div className="">
                      <ul className="text-gray-500 text-base text-justify my-2 ">
                        <li className="">{listText}</li>
                      </ul>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UniticketAlimentacion;
